'use client'

import { BorrowHubPage } from '@/containers/BorrowHub'

export default function ExploreBorrowPage() {
  return <BorrowHubPage defaultView="explore" />
}
